import { FBF_CloudCallable } from '@rabbit/firebase/adapter';

export interface UpdateHoldingConsumerRequest {
  holdingLink: string;
  consumerLink?: string;
  newConsumer?: {
    firstName: string;
    lastName: string;
    email: string;
    telephone?: string;
    address?: any;
    isCommercial?: boolean;
  };
  tenantLink?: string;
  transferReason?: string;
}

export interface UpdateHoldingConsumerResponse {
  success: boolean;
  message: string;
  holdingLink: string;
  consumerLink: string;
  tenantLink: string;
}

export const nestApiUpdateHoldingConsumer = FBF_CloudCallable<
  UpdateHoldingConsumerRequest,
  UpdateHoldingConsumerResponse
>('api/holding/updateHoldingConsumer|PUT');
